var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"flex-row flex-justify-center flex-align-center w-100 h-100",staticStyle:{"font-size":"3em"}},[_vm._v(" Coming soon... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }